<!-- 库存管理 -->
<template>
<div class='inventory'>
  <Head :goBack='true' show="" title="库存管理"></Head>
  <div class="kong">&nbsp;</div>
  <!-- 设备 -->
  <ul class="facility_ul">
    <li class="facility_li">
      <div class="facility_header">
        <div class="facility_header_bgimg">
          <img :src="require('@/assets/images/icon.png')" alt="">
        </div>
        <div class="facility_header_right">
          <h3>设备编号 : {{millInfo.deviceCode}}</h3>
          <p>运营编号 : {{millInfo.deviceNum}}</p>
          <p>设备类型 : {{millInfo.deviceType}}</p>
        </div>
      </div>
      <div class="facility_footer">
        <div class="facility_footer_left">
          <i></i>
          <span class="facility_footer_left_span" @click="lineShow=true">选择路数 : </span>
          <span v-if="selectedMill">({{selectedMill.key}}路)</span>
        </div>
        <van-button class="facility_footer_btn" 
                    :icon="require('@/assets/images/jiesuo.png')" 
                    @click="upUnlocking"
                    type="info">
          开锁
        </van-button>
      </div>
    </li>
  </ul>
  <!-- 容量 -->
  <ul class="capacity_ul" v-if="capacityShow">
    <li class="capacity_header">
      <div class="capacity_header_left">
        <span>设备容量 : {{selectedMill.maxStock}} {{selectedMill.nuit}}</span>
        <span>当前库存 : {{selectedMill.currentStock}} {{selectedMill.nuit}}</span>
      </div>
      <van-button class="facility_footer_btn capacity_btn" type="info" @click="topUpMill">加满提交</van-button>
    </li>
    <li class="capacity_footer">
      <div class="capacity_footer_costom">
        <span>自定义 : </span>
        <!-- 允许输入数字，调起带符号的纯数字键盘 -->
        <van-field class="capacity_footer_costom_input" v-model="milliliter" @input="millInput" type="number"/>
        <span>{{selectedMill.nuit}}</span>
      </div>
      <van-button class="facility_footer_btn capacity_btn" type="info" @click="customMill">提交</van-button>
    </li>
  </ul>

  <!-- 弹窗确认 -->
  <van-dialog v-model="unlockingShow" 
              title="提示" message="确认要开锁吗" 
              confirm-button-color="#0075fd"
              cancel-button-color="#8d8d8d"
              @confirm="confirmLock"
              show-cancel-button>
  </van-dialog>
  <!-- 弹出底部线路 -->
  <van-popup  v-model="lineShow" 
              position="bottom" 
              :safe-area-inset-bottom="true"
              :style="{ height: '35%' }">
              <div class="van-popup-header">
                选择线路
                <van-button class="van-popup-btn" type="default" @click="confirmMill">确定</van-button>
              </div>
              <ul class="van-popup-ul">
                <li :class="{'mill_active' : selectedMill === mill}"
                    v-for="mill of millList" 
                    @click="selectedMill = mill"
                    :key="mill.id">
                  <span>{{mill.key}}路 {{mill.goodTitle}}</span>
                  <van-icon v-if="selectedMill === mill" name="success" />
                </li>
              </ul>
  </van-popup>
</div>
</template>

<script>
import { Toast  } from "vant";
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  //输入毫升数量
  milliliter : '',
  //是否开锁确认弹窗
  unlockingShow: false,
  //线路弹窗
  lineShow: false,
  //容量展示
  capacityShow:false,
  //当前机器
  millInfo:{},
  //货道列表
  millList: [],
  // 当前选中货道
  selectedMill: null,
  //定时器开关
  requestTimes:null,
  //开锁弹窗
  toastTime:null,
  index: 0
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  //点击开锁
  upUnlocking() {
    if (!this.selectedMill) {
      Toast("请选择线路")
      return;
    }
    this.unlockingShow = true;
  },
  //确认开锁
  confirmLock() {
    let params = {
      millCellId: this.selectedMill.id,
      deviceNum: this.deviceNum
    }
    new Promise((resolve,reject) => {
      this.$api.inventory.cellOpen(params).then(res=>{
        if (res.code === 200) {
          resolve(res.requestId);
        } else {
          Toast(res.msg);
        }
      })
    }).then(requestId => {
      this.toastTime = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '开锁中',
      });
      setTimeout(() =>{
        this.requestTimes = setInterval(() => {
          this.index++;
          if (this.index <= 2) {
            this.queryLock(requestId);
          } else {
            this.toastTime.clear();
            clearInterval(this.requestTimes);
            Toast.fail({
              forbidClick: true,
              message: "开锁失败,请稍后重试"
            })
            this.index = 0;
          }
        }, 2000);
      },2000)
    })
  },
  //查询开锁结果
  queryLock(requestId) {
    let params = {
      requestId: requestId
    }
    this.$api.inventory.cellOpenQuery(params).then((res)=>{
      if (res.code === 200) {
        clearInterval(this.requestTimes);
        this.toastTime.clear();
        Toast.success({
          forbidClick: true,
          message: '开锁成功',
        });
      }
    })
  },
  //加满货道
  topUpMill() {
    let params = {
      millCellId: this.selectedMill.id,
      deviceNum: this.deviceNum
    }
    this.$api.inventory.cellFillAll(params).then(res => {
      if (res.code === 200) {
        Toast(res.msg);
        this.getCellList('topUpMill');
      } else {
        Toast(res.msg);
      }
    })
  },
  //自定义补货道数量
  customMill() {
    let params = {
      millCellId: this.selectedMill.id,
      deviceNum: this.deviceNum,
      currentStock: this.milliliter
    }
    this.$api.inventory.cellFillCustom(params).then((res)=>{
      if (res.code === 200) {
        Toast(res.msg);
        this.milliliter = '';
        this.getCellList('customMill');
      } else {
        Toast(res.msg);
      }
    })
  },
  //获取机器货道列表
  getCellList(from) {
    let params = {
      deviceNum: this.deviceNum,
      openId: ''
    }
    this.$api.inventory.cellList(params).then((res)=>{
      if (res.code === 200) {
        res.result.map((item,index) => {
          item.key = index + 1;
        })
        this.millInfo = res;
        this.millList = res.result;
        if (from && this.millList.length) {
          this.selectedMill = this.millList.filter(item => {return this.selectedMill.id === item.id})[0];
        }
      } else {
        Toast(res.msg)
      }
    })
  },
  //确定线路
  confirmMill() {
    this.capacityShow = true;
    this.lineShow = false;
  },
  millInput(value) {
    if (value >= this.selectedMill.maxStock) {
     this.milliliter = this.selectedMill.maxStock;
    }
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.getCellList();
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {
  if (this.toastTime) this.toastTime.clear();
  clearInterval(this.requestTimes);
}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
  .kong{
    width: 100%;
    height: 130px;
    background-color: #f7f8fa;
  }
  .inventory{
    background-color: #f7f8fa;
    .facility_ul{
      box-shadow: 0 8px 12px #ebedf0;
      background-color: #fff;
      padding: 20px 25px;
      .facility_li{
        .facility_header{
          display: flex;
          height: 260px;
          justify-content: space-between;
          align-items: flex-start;
          .facility_header_bgimg{
            width: 260px;
            height: 260px;
            background: url('~@/assets/images/di.png') no-repeat center center;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              width: 175px;
              height: 150px;
            }
          }
          
          .facility_header_right{
            flex: 1;
            height: 100%;
            padding-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            h3{
              color:#4686f4;
              font-size: 28px;
              line-height: 40px;
              font-weight: bold;
            }
            p{
              font-size: 28px;
              color:#666666;
            }
          }
        }
        .facility_footer{
          margin-top: 20px;
          padding: 10px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .facility_footer_left{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 30px;
            i{
              width: 50px;
              height: 50px;
              display: inline-block;
              background: url('~@/assets/images/xuanzelushu.png') no-repeat;
              background-size: 100% 100%;
            }
            span{
              color:#666666;
            }
            .facility_footer_left_span{
              padding: 0 15px;
              color:#4686f4;
              font-weight: bold;
            }
          }
        }
      }
    }

    //按钮样式
    .facility_footer_btn{
      width: 220px;
      height: 80px;
      line-height: 80px;
      background-color:#33c779;
      color:#fff;
      border-radius: 15px;
      font-size: 30px;
      border: 0;
    }

    .capacity_ul{
      background-color: #fff;
      padding: 0 25px;
      margin: 25px 0;
      color:#464646;
      font-size: 30px;
      //按钮样式
      .capacity_btn{
        background-color: #4686f4;
        height: 65px;
        line-height: 65px;
      }
      .capacity_header{
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e4e4e4;
        .capacity_header_left{
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          span{
            padding: 10px 0;
            font-weight: bold;
          }
        }
      }
      .capacity_footer{
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .capacity_footer_costom{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .capacity_footer_costom_input{
            margin: 0 20px;
            width: 170px;
            border: 1px solid #8e8e8e;
            padding: 0px 15px;
          }
          span{
            font-weight: bold;
          }
        }
      }
    }
    .van-dialog{
      width: 540px;
      border-radius: 20px;
      ::v-deep.van-dialog__content{
        border-bottom: 1px solid #8d8d8d;
      }
      ::v-deep.van-dialog__cancel{
       border-right: 1px solid #8d8d8d;
      }
    }
    .van-popup-header{
      position: sticky;
      top: 0;left: 0;right: 0;
      background-color: #fff;
      width: 100%;
      height: 70px;
      line-height: 70px;
      text-align: center;
      font-size: 28px;
      color:#2973f1;
      border-bottom: 1px solid #dedede;
      box-sizing: border-box;
      font-weight: bold;
      .van-popup-btn{
        height: 100%;
        line-height: 100%;
        background-color: #fff;
        position: absolute;
        top: 0;right: 0;bottom: 0;
        float: right;
        border: 0;
        color:#3cba22;
      }
    }
    .van-popup-ul{
      padding:0 25px;
      li{
        box-sizing: border-box;
        padding: 25px 0;
        border-bottom: 1px solid #dedede;
        font-size: 32px;
        color:#181818;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      li:last-child{
        border: 0;
      }
      .mill_active{
        font-weight: bold;
        color:#4686f4;
      }
    }
  }
</style>